import { Link } from "react-router-dom";

const friendlyLinks = [
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "短视频频道", to: "/category/short" },
  { label: "站内搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-800 bg-background-900">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-10 md:grid-cols-4 md:px-6 md:py-14">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-950">
              <i className="ri-play-circle-fill text-xl" />
            </span>
            <span className="font-heading text-xl font-extrabold text-foreground-50">
              多多<span className="text-accent-500">视频</span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-300">
            多多视频专注于高清影视资源分享与精彩视频播放，涵盖电影、电视剧与短视频内容，致力于帮助用户快速发现优质影视作品，享受便捷流畅的浏览与观看体验。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 text-foreground-200">
              <i className="ri-wechat-line text-lg" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 text-foreground-200">
              <i className="ri-weibo-line text-lg" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 text-foreground-200">
              <i className="ri-mail-line text-lg" />
            </span>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-foreground-100">
            快捷导航
          </h4>
          <ul className="mt-4 space-y-3">
            {friendlyLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="whitespace-nowrap text-sm text-foreground-300 transition-colors hover:text-accent-400 cursor-pointer"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-foreground-100">
            友情链接
          </h4>
          <ul className="mt-4 space-y-3">
            <li>
              <a
                href="https://duxcm.cn"
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap text-sm text-foreground-300 transition-colors hover:text-accent-400 cursor-pointer"
              >
                哔哩哔哩
              </a>
            </li>
            <li>
              <a
                href="https://www.douban.com"
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap text-sm text-foreground-300 transition-colors hover:text-accent-400 cursor-pointer"
              >
                豆瓣电影
              </a>
            </li>
            <li>
              <a
                href="https://www.iqiyi.com"
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap text-sm text-foreground-300 transition-colors hover:text-accent-400 cursor-pointer"
              >
                爱奇艺
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="mx-auto flex w-full flex-col items-center gap-2 px-4 py-5 text-center text-xs text-secondary-400 sm:flex-row sm:justify-between sm:text-left md:px-6">
          <span>© 2026 多多视频 · 高清影视资源分享与精彩视频播放平台</span>
          <span className="whitespace-nowrap">本站内容均为演示数据，仅用于产品展示</span>
        </div>
      </div>
    </footer>
  );
}